import { render } from "./AssignmentTemplateCard.vue?vue&type=template&id=53acd7ec&scoped=true"
import script from "./AssignmentTemplateCard.vue?vue&type=script&lang=js"
export * from "./AssignmentTemplateCard.vue?vue&type=script&lang=js"

import "./AssignmentTemplateCard.vue?vue&type=style&index=0&id=53acd7ec&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./AssignmentTemplateCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53acd7ec"]])

export default __exports__